<template>
  <div id="newSurvey">
    <topBar :title="$t('newSurvey.title')" />
    <div class="commonContainer">
      <div class="filterConditionContainer">
        <el-card class="box-card">
          <div class="filterCondition">
            <div class="searchIcon">
              <i class="el-icon-search"></i>
            </div>
            <el-form :inline="true" :model="filterForm" class="filterForm" label-width="98px">
              <el-form-item :label="$t('survey.name')">
                <el-input v-model="filterForm.name" :placeholder="$t('survey.chooseName')"></el-input>
              </el-form-item>
              <!-- <el-form-item :label="$t('survey.surveyType')">
                <el-select v-model="filterForm.type" clearable placeholder="请选择问卷类型">
                  <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item :label="$t('newSurvey.createTime')">
                <el-date-picker v-model="filterForm.date" type="daterange" align="left" unlink-panels
                  range-separator=" - " :start-placeholder="$t('survey.startTime')"
                  :end-placeholder="$t('survey.endTime')" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('newSurvey.publishTime')" v-if="[1].indexOf(published) > -1">
                <el-date-picker v-model="filterForm.date2" type="daterange" align="left" unlink-panels
                  range-separator=" - " :start-placeholder="$t('survey.startTime')"
                  :end-placeholder="$t('survey.endTime')" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('newSurvey.stopTime')" v-if="[2].indexOf(published) > -1">
                <el-date-picker v-model="filterForm.date3" type="daterange" align="left" unlink-panels
                  range-separator=" - " :start-placeholder="$t('survey.startTime')"
                  :end-placeholder="$t('survey.endTime')" value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-form-item>
            </el-form>
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="8">
                <div class="filterBtns">
                  <el-button type="primary" @click="onSearch(true)">{{ $t('search') }}</el-button>
                  <el-button type="primary" @click="onAdd" v-if="[0].indexOf(published) > -1 && isAdmin">{{ $t('add')
                    }}</el-button>
                  <el-button type="primary" @click="onReset">{{ $t('reset') }}</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </div>
      <div class="tableContainer">
        <el-card class="box-card">
          <div class="tableBox">
            <div class="orangeIcon">
              <i class="el-icon-s-order"></i>
            </div>
          </div>
          <div style="margin-top: 20px">
            <el-table :data="tableData" style="width: 100%" :key="1" v-loading="tableLoading">
              <el-table-column prop="name" :label="$t('newSurvey.surveyName')">
              </el-table-column>
              <!-- <el-table-column prop="type" :label="$t('newSurvey.surveyType')">
                <template slot-scope="scope">
                  {{ scope.row.type == 1 ? '开放问卷' : '巡店问卷' }}
                </template>
              </el-table-column> -->
              <el-table-column v-if="[0, 1].indexOf(published) > -1" prop="publishTimeDisplay"
                :label="(published == 0 ? '自动' : '') + $t('newSurvey.publishTime')" width="120">
              </el-table-column>
              <el-table-column prop="stopTimeDisplay"
                :label="([1, 0].indexOf(published) > -1 ? '自动' : '') + $t('newSurvey.stopTime')" width="120">
              </el-table-column>
              <el-table-column prop="createTime" :label="$t('newSurvey.createTime')" width="120">
              </el-table-column>
              <el-table-column prop="updateTimeDisplay" :label="$t('newSurvey.updateTime')" width="120">
              </el-table-column>
              <el-table-column prop="publishedStatus" :label="$t('newSurvey.status')" width="100">
              </el-table-column>
              <el-table-column :label="$t('operation')" :width="published == 0 ? 520 : published == 1 ? 510 : 410"
                fixed="right">
                <template slot-scope="scope">
                  <!-- <el-button v-if="[0, 1].indexOf(published) > -1" @click="downloadDoorQrcode(scope.row)" type="text"
                    size="small">{{ $t('newSurvey.downloadDoorCode') }}</el-button> -->
                  <el-button @click="previewSurvey(scope.row)" type="text" size="small">{{ $t('survey.preview')
                    }}</el-button>
                  <el-button v-if="[0].indexOf(published) > -1 && isAdmin" @click="editSurvey(scope.row)" type="text"
                    size="small">{{ $t('survey.edit') }}</el-button>
                  <el-button v-if="[0, 1].indexOf(published) > -1 && isAdmin"
                    @click="toggleStatus(scope.row.published, scope.row)" type="text" size="small">{{ !published ?
      $t('newSurvey.publish') : $t('newSurvey.stopPublish') }}</el-button>
                  <el-button v-if="[2].indexOf(published) > -1 && isAdmin" @click="viewSurvey(scope.row)" type="text"
                    size="small">{{ $t('newSurvey.view') }}</el-button>
                  <el-button v-if="isAdmin" @click="copySurvey(scope.row)" type="text" size="small">{{
      $t('newSurvey.copy') }}</el-button>
                  <el-button v-if="[0, 1].indexOf(published) > -1 && isAdmin"
                    :disabled="!scope.row.qrcodeImage || scope.row.qrcodeImage == ''" @click="downloadCode(scope.row)"
                    type="text" size="small">{{ $t('newSurvey.downloadCode') }}</el-button>
                  <!-- <el-button v-if="[1, 2].indexOf(published) > -1 && (isAdmin||canDownload)" @click="exportData(scope.row)" type="text"
                    size="small">{{ $t('newSurvey.exportData') }}A</el-button> -->
                                      <el-button v-if="[1, 2].indexOf(published) > -1 && (isAdmin||canDownload)" @click="exportData2(scope.row)" type="text"
                    size="small">{{ $t('newSurvey.exportData') }}</el-button>
                  <el-button v-if="[0, 2].indexOf(published) > -1 && isAdmin" @click="deleteSurvey(scope.row)"
                    type="text" size="small">{{ $t('delete') }}</el-button>
                  <el-button v-if="[2].indexOf(published) > -1 && isAdmin" @click="reEditSurvey(scope.row)" type="text"
                    size="small">{{ $t('newSurvey.onShelf') }}</el-button>
                  <el-button v-if="[0].indexOf(published) > -1 && isAdmin" @click="unShelfSurvey(scope.row)" type="text"
                    size="small">{{ $t('newSurvey.unShelf') }}</el-button>
                  <el-button v-if="[1, 2].indexOf(published) > -1 && (isAdmin||canDownload)" @click="showCollection(scope.row)"
                    type="text" size="small">{{ $t('newSurvey.collection') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagingBox">
              <el-pagination background @current-change="currentChange" :current-page="current"
                layout="total, prev, pager, next, jumper" :total="total">
              </el-pagination>
            </div>
          </div>
        </el-card>
      </div>
    </div>
    <el-dialog key="questionnaire-door" :title="questionnaireName + '-' + $t('newSurvey.doorList')"
      :visible.sync="doorDialog" width="80%" center top="0">
      <el-form :inline="true" :model="dialogfilterForm" class="filterForm" label-width="65px">
        <el-form-item :label="$t('filters.doorName')">
          <el-input v-model="dialogfilterForm.name" :placeholder="$t('filters.chooseDoorName')"></el-input>
        </el-form-item>
        <el-form-item :label="'门店编号'">
          <el-input v-model="dialogfilterForm.posId" :placeholder="$t('filters.choosePOSID')"></el-input>
        </el-form-item>
        <el-button type="primary" @click="() => { dialogfilterForm.current = 1; onDoorSearch(); }">{{ $t('search')
          }}</el-button>
        <el-button type="primary" @click="onDoorReset">{{ $t('reset') }}</el-button>
        <el-button style="position: absolute;right:20px" type="primary" @click="onDoorExport">{{
      $t('newSurvey.exportDoor')
    }}</el-button>
      </el-form>
      <div style="margin-top: 20px">
        <el-table :data="doorData" :key="2" style="width: 100%" v-loading="doorLoading">
          <el-table-column fixed prop="doorName" :label="$t('store.doorName1')" width="280">
          </el-table-column>
          <el-table-column prop="posId" label="门店编号" width="120">
          </el-table-column>
          <el-table-column prop="cityName" :label="$t('filters.city')" width="120">
          </el-table-column>
          <el-table-column prop="regionName" :label="$t('filters.region')" width="120">
          </el-table-column>
          <el-table-column prop="resellerName" :label="$t('filters.reseller')" width="120">
          </el-table-column>
          <el-table-column prop="subReseller" :label="$t('filters.subReseller')" width="120">
          </el-table-column>
          <el-table-column prop="concept" label="CONCEPT" width="170">
          </el-table-column>
          <el-table-column prop="clusterName" label="Cluster Name" width="120">
          </el-table-column>
          <el-table-column prop="clusterGroup" label="City Tier" width="170">
          </el-table-column>
          <el-table-column prop="tzGroup" label="TZ Group" width="120">
          </el-table-column>
          <el-table-column prop="format" label="Format" width="120">
          </el-table-column>
          <el-table-column prop="hub" label="Hubdoor" width="120" :formatter="hubdoorFormatter">
          </el-table-column>
          <el-table-column :label="$t('operation')" fixed="right" width="200">
            <template slot-scope="scope">
              <el-button v-if="isAdmin" @click="doorForbidden(scope.row)" type="text" size="small">{{
      scope.row.forbidden ? $t('newSurvey.active') : $t('newSurvey.forbidden') }}</el-button>
              <el-button :disabled="scope.row.forbidden" @click="downloadDoorQrcodeActual(scope.row)" type="text"
                size="small">{{ $t('newSurvey.downloadDoorCode') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagingBox">
          <el-pagination background @current-change="currentChange2" :current-page="dialogfilterForm.current"
            :page-size="7" layout="total, prev, pager, next, jumper" :total="doorTotal">
          </el-pagination>
        </div>
      </div>
    </el-dialog>

    <el-dialog key="questionnaire-collection" :title="'问卷收集详情'" :visible.sync="collectDialog" width="90%" top="0">
      <span>问卷名称：{{ filterForm2.name }}</span>
      <el-form :inline="true" :model="filterForm2" class="filterForm" label-width="68px" style="margin-top: 20px;">
        <el-form-item :label="'提交时间'">
          <el-date-picker style="width:240px" v-model="filterForm2.date" type="daterange" align="left" unlink-panels
            range-separator=" - " :start-placeholder="$t('survey.startTime')" :end-placeholder="$t('survey.endTime')"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item :label="'客户'">
          <el-select v-model="filterForm2.resellers" multiple placeholder="请选择客户" collapse-tags>
            <el-option v-for="item in resellerOptions" :key="item.resellerNo" :label="item.name" :value="item.resellerNo">
            </el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="() => { filterForm2.current = 1; onCollectionSearch(); }">{{ $t('search')
          }}</el-button>
        <el-button type="primary" @click="onCollectionReset">{{ $t('reset') }}</el-button>
        <el-button style="position: absolute; right: 20px;" type="primary" @click="onCollectionExport()">导出图片</el-button>
      </el-form>

      <div style="margin-top: 20px">
        <el-table :data="collections" :key="2" style="width: 100%" v-loading="tableLoading3">
          <el-table-column prop="id" label="提交ID" width="100">
          </el-table-column>
          <el-table-column prop="name" label="提交人" width="120">
          </el-table-column>
          <el-table-column prop="roleName" label="提交人角色" width="120">
          </el-table-column>
<!--          <el-table-column prop="email" label="提交人邮箱" width="120">-->
<!--          </el-table-column>-->
          <el-table-column prop="createTime" label="提交时间" width="140">
          </el-table-column>
          <el-table-column prop="resellerName" label="客户" width="140">
          </el-table-column>
          <el-table-column prop="posId" label="门店编号" width="100">
          </el-table-column>
          <el-table-column prop="doorName" label="门店" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="imageCount" label="图片数" width="70">
          </el-table-column>
          <el-table-column :label="$t('operation')" fixed="right" width="80">
            <template slot-scope="scope">
              <el-button @click="onCollectionExport(scope.row.id)" type="text" :disabled="scope.row.imageCount==0"
                size="small">导出图片</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagingBox">
          <el-pagination background @current-change="currentChange3" :current-page="filterForm2.current"
            :page-size="7" layout="total, prev, pager, next, jumper" :total="total3">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TopBar from '../components/TopBar.vue'
import _ from 'lodash'
export default {
  name: 'NewSurvey',
  components: {
    topBar: TopBar
  },
  data: function () {
    return {
      filterForm: {
      },
      filterForm2: {
        id: 0,
        submitId: 0,
        name: '',
        date: null,
        resellers: [],
        size: 7,
        current: 1,
      },
      dialogfilterForm: {
        id: 0,
        name: '',
        posId: '',
        size: 7,
        current: 1,
      },
      doorLoading: false,
      doorTotal: 0,
      doorData: [],
      initFilterForm: {
        published: 1, // 状态
        type: null,
        name: '', // 问卷名称
        date: '', // 日期
        date2: '',
        date3: '',
      },
      typeOptions: [
        {
          value: 1,
          label: '开放问卷'
        },
        {
          value: 2,
          label: '巡店问卷'
        }

      ],
      resellerOptions:[],
      tableData: [], // 表格数据
      total: 0,
      current: 1, // 当前页码
      tableLoading: false,
      published: 1,
      questionnaireName: '',
      doorDialog: false,
      collectDialog: false,
      collections:[],
      total3: 0,
      current3: 1, // 当前页码
      tableLoading3: false,
      canDownload: false,
    }
  },

  async beforeMount() {
    this.published = Number(this.$route.query.published || 1);
    this.initFilterForm.published = this.published;
    await this.getCanDownload()
    this.onReset()
    this.onSearch()
    this.loadReseller()
  },
  watch: {
    $route(val) {
      this.published = Number(this.$route.query.published || 1);
      this.initFilterForm.published = this.published;
      this.onReset()
      this.onSearch()
    }
  },
  computed: {
    // statusOptions () {
    //   return [{
    //     label: '已发布',
    //     value: true
    //   },
    //   {
    //     label: '未发布',
    //     value: false
    //   }]
    // },
    // canDownload: ({ $store: { getters } }) => {
    //   console.log(getters.canDownload)
    //   if (getters.canDownload + "" === "true") {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },
    roleCode: ({ $store: { getters } }) => {
      return getters.roleCode
    } ,
    isAdmin: ({ $store: { getters } }) => {
      if (getters.isAdmin + '' === 'true') {
        return true
      } else {
        return false
      }
    } // 角色是否是admin
  },
  methods: {
    loadReseller: async function(){
      let res = await window.instance.get(window.pubServer + 'common/getReseller')
      res = res.data
      if (res.code === 200) {
        this.resellerOptions = res.data.resellerList
      }
    },
    onSearch: async function (resetPage) {
      if (resetPage) {
        this.current = 1
      }
      this.tableLoading = true
      const submitData = {
        name: this.filterForm.name,
        startTime: this.filterForm.date ? this.filterForm.date[0] : '',
        endTime: this.filterForm.date ? this.filterForm.date[1] : '',
        publishStartTime: this.filterForm.date2 ? this.filterForm.date2[0] : '',
        publishEndTime: this.filterForm.date2 ? this.filterForm.date2[1] : '',
        stopStartTime: this.filterForm.date3 ? this.filterForm.date3[0] : '',
        stopEndTime: this.filterForm.date3 ? this.filterForm.date3[1] : '',
        published: this.filterForm.published,
        type: this.filterForm.type ? this.filterForm.type : null,
        size: 10,
        current: this.current
      }
      let res = await window.instance.post(openSurveyReqUrl + 'questionnaire/list', submitData)
      res = res.data
      if (res.code === 200) {
        const list = res.data.list
        this.total = res.data.total
        this.tableData = list
      }
      this.tableLoading = false
    },
    onDoorSearch: async function () {
      this.doorLoading = true
      let res = await window.instance.post(openSurveyReqUrl + 'doors/query', this.dialogfilterForm)
      res = res.data
      if (res.code === 200) {
        const list = res.data.list
        this.doorTotal = res.data.total
        this.doorData = list
      }
      this.doorLoading = false
    },
    onCollectionSearch: async function(){
      this.filterForm2.submitId = 0
      if(this.filterForm2.date&&this.filterForm2.date.length>1){
      this.filterForm2.startTime = this.filterForm2.date[0]
      this.filterForm2.endTime = this.filterForm2.date[1]
      }else{
        delete this.filterForm2.startTime
        delete this.filterForm2.endTime
      }
      this.tableLoading3 = true
      let res = await window.instance.post(openSurveyReqUrl+ 'questionnaire/collections', this.filterForm2)
      res = res.data
      if (res.code === 200) {
        const list = res.data.list
        this.total3 = res.data.total
        this.collections = list
      }
      this.tableLoading3 = false
    },
    onDoorExport: function () {
      this.$tool.exportFile({ method: 'post', url: openSurveyReqUrl+ 'doors/export', data: this.dialogfilterForm })
    },
    onCollectionExport: function (id){
      if(id){
        this.filterForm2.submitId = id
      }else{
        this.filterForm2.submitId = 0
      }

      this.$tool.exportFile({ method: 'post', url: openSurveyReqUrl+ 'questionnaire/images', data: this.filterForm2 })

    },

    onDoorReset: function () {
      this.dialogfilterForm.name = ''
      this.dialogfilterForm.posId = ''
      this.dialogfilterForm.current = 1
      this.doorTotal = 0;
    },
    onCollectionReset: function () {
      this.filterForm2.resellers = []
      this.filterForm2.date = null
      delete this.filterForm2.startTime
      delete this.filterForm2.endTime
      this.filterForm2.submitId = 0
      this.filterForm2.current = 1
      this.total3 = 0;
    },
    doorForbidden: async function (row) {
      let doorEdit = {
        id: this.dialogfilterForm.id,
        posId: row.posId,
        status: !row.forbidden
      }
      window.instance.post(openSurveyReqUrl+ 'doors/status/edit', doorEdit)
      row.forbidden = doorEdit.status;
    },
    currentChange: function (index) {
      // 分页
      this.current = index
      this.onSearch(false)
    },
    currentChange2: function (index) {
      this.dialogfilterForm.current = index
      this.onDoorSearch(false)
    },
    currentChange3: function (index) {
      this.filterForm2.current = index
      this.onCollectionSearch(false)
    },
    onReset: function () {
      this.filterForm = _.cloneDeep(this.initFilterForm)
    },
    hubdoorFormatter: function (row) {
      return row.hub == 1 ? this.$t('yes') : this.$t('no')
    },
    onAdd: function () {
      this.$router.push({ path: '/openSurvey/editNewSurvey', query: { published: this.published } })
    },
    toggleStatus: async function (status, row) {
      let postUrl = ''
      if (status) {
        // 已发布
        postUrl = 'unPublish'
      } else {
        postUrl = 'publish'
      }
      let confirm = await this.$tool.secondConfirm(status ? `确认停止发布问卷《${row.name}》？` : `确认发布问卷《${row.name}》？`);
      if (!confirm) return;

      let res = await window.instance.post(openSurveyReqUrl+ 'questionnaire/' + row.id + '/' + postUrl)
      res = res.data
      if (res.code === 200) {
        await this.onSearch(false)
        this.$message.success(res.message)
      } else {
        // this.$message.warning(res.message)
      }
    },
    reEditSurvey: async function (row) {
      let confirm = await this.$tool.secondConfirm(`确认上架问卷《${row.name}》？`);
      if (!confirm) return;

      let res = await window.instance.post(openSurveyReqUrl+ 'questionnaire/' + row.id + '/onShelf')
      res = res.data
      if (res.code === 200) {
        await this.onSearch(false)
        this.$message.success(res.message)
      } else {
        // this.$message.warning(res.message)
      }
    },
    showCollection: function (row) {
      this.filterForm2.id = row.id
      this.filterForm2.submitId = 0
      this.filterForm2.name = row.name
      this.onCollectionSearch()
      this.collectDialog = true
    },
    unShelfSurvey: async function (row) {
      let confirm = await this.$tool.secondConfirm(`确认下架问卷《${row.name}》？`);
      if (!confirm) return;

      let res = await window.instance.post(openSurveyReqUrl+ 'questionnaire/' + row.id + '/unShelf')
      res = res.data
      if (res.code === 200) {
        await this.onSearch(false)
        this.$message.success(res.message)
      } else {
        // this.$message.warning(res.message)
      }
    },
    editSurvey: function (row) {
      this.$router.push({ path: '/openSurvey/editNewSurvey', query: { id: row.id, isCopy: 0, published: this.published } })
    },
    viewSurvey: function (row) {
      this.$router.push({ path: '/openSurvey/editNewSurvey', query: { id: row.id, isCopy: 0, published: this.published } })
    },
    deleteSurvey: function (row) {
      const tipContent = this.$t('survey.deleteSurvey') + `《${row.name}》吗?`
      const tip = this.$t('tip')
      this.$confirm(tipContent, tip, {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      })
        .then(async () => {
          let res = await window.instance.post(openSurveyReqUrl+ 'questionnaire/' + row.id + '/del')
          res = res.data
          if (res.code === 200) {
            await this.onSearch(false)
            this.$message.success(res.message)
          } else {
            // this.$message.warning(res.message)
          }
        })
        .catch(_ => { })
    },
    previewSurvey: function (row) {
      // todo: 预览问卷
      let routeData = this.$router.resolve({ path: '/previewSurvey', query: { id: row.id } })
      window.open(routeData.href, '_blank')
      // this.$router.push({path: '/previewSurvey', query: { id: row.id }})
    },
    downloadCode: function (row) {
      if (!row.qrcodeImage) {
        this.$message.warning('请上传问卷二维码背景后再尝试下载二维码！')
      } else {
        let url = new URL(row.qrcodeImage);
        let expired = Number(url.searchParams.get('Expires')) * 1000 < Date.now();
        if (expired) {
          router.push('/login');
        }
        window.open(row.qrcodeImage)
      }
    },
    copySurvey: function (row) {
      this.$router.push({ path: '/openSurvey/editNewSurvey', query: { id: row.id, isCopy: 1, published: this.published } })
    },
    downloadDoorQrcode: async function (row) {
      this.dialogfilterForm.id = row.id;
      this.dialogfilterForm.posId = '';
      this.dialogfilterForm.name = ''
      this.questionnaireName = row.name;
      this.doorTotal = 0;
      this.doorDialog = true;
      this.dialogfilterForm.current = 1;
      this.onDoorSearch();
    },
    downloadDoorQrcodeActual: function (row) {
      this.$tool.exportFile({ method: 'get', url: openSurveyReqUrl+ `doors/qrCode?questionnaireId=${this.dialogfilterForm.id}&posId=${row.posId}`, data: {} })
    },
    exportData: async function (row) {
      let { data, fileName } = await this.$tool.exportFile({
        method: 'get',
        url: openSurveyReqUrl+ 'questionnaire/' + row.id + '/data'
      })
      console.log(data, fileName)
    },
        exportData2: async function (row) {
      let { data, fileName } = await this.$tool.exportFile({
        method: 'get',
        url: openSurveyReqUrl+ 'questionnaire/' + row.id + '/data2'
      })
      console.log(data, fileName)
    },
    getCanDownload: async function() {
      let { data } = await window.instance.get(
        openSurveyReqUrl+ "account/canViewReport"
      );
      this.canDownload = data.data.result;
    }
  }
}
</script>

<style scoped lang="sass">
</style>



// WEBPACK FOOTER //
// src/openSurvey/pages/NewSurvey.vue